<div class="content">

    <div class="text-left mt-5">

        <h3>Generate Access token and Secret key</h3> <br><br><br>

        <p><b>Our system provides two types of authentication:</b> IdToken and Basic Auth(access token with a secret
            key). Both of these methods are supported by all of our APIs. However, it's important to note that when
            utilizing web sockets, only IdToken authentication is allowed. This means that for regular API requests,
            clients can choose to authenticate using either an IdToken or Basic Auth (access token and secret key),
            depending on their preference and requirements. But for web socket connections, the use of IdToken is
            mandatory. If you have any further questions or need more information about our authentication methods,
            please don't hesitate to ask. </p>

        <p>Login to Dashboard and go to settings=>Create Access Token.
            Give any name and create the access token and secret key (Basic Auth) </p><br><br>


        <img src="/assets/images/accesstoken.png" class="img-thumbnail" alt="login">


        <p class="mt-5"><b>Please see below examples on how you can use authentication tokens.</b></p><br>


        <h5>Using Basic Auth:</h5><br><br>


        <div class="card text-bg-dark mb-3">
            <div class="card-body">

                <div class="card-title">
                    <button style="float: right;" *ngIf="copyButton" class="btn btn-outline-primary btn-sm"
                        (click)="copyJsonToClipboard()">
                        <i class="fa fa-clipboard" aria-hidden="true"></i>
                    </button>

                    <button style="float: right;" *ngIf="copiedButton" class="btn btn-success btn-sm">
                        Copied <i class="fa fa-check" aria-hidden="true"></i>
                    </button>

                </div><br><br>

                <pre><code  >{{ jsonData }}</code></pre>

            </div>
        </div><br><br>

        <p>
            In this example, replace <b>access_token</b> with your actual access token and <b>secret_key</b> with your
            secret key. The
            <b>-u</b> option is used to specify the username and password for Basic Auth.
        </p><br><br><br>


        <h5>Using IdToken:</h5><br><br>

        <div class="card text-bg-dark mb-3">
            <div class="card-body">

                <div class="card-title">
                    <button style="float: right;" *ngIf="copyButton1" class="btn btn-outline-primary btn-sm"
                        (click)="copyJsonToClipboard1()">
                        <i class="fa fa-clipboard" aria-hidden="true"></i>
                    </button>

                    <button style="float: right;" *ngIf="copiedButton1" class="btn btn-success btn-sm">
                        Copied <i class="fa fa-check" aria-hidden="true"></i>
                    </button>

                </div><br><br>

                <pre><code  >{{ jsonData1 }}</code></pre>

            </div>
        </div><br><br>


        <p>
            In this example, replace <b>idtokenxxx</b> with your actual IdToken. The <b>-H</b> option is used to add a custom header
            to the request, and we set the <b>authorization</b> header to include the IdToken. Note that the specific format of
            the IdToken may vary depending on the API requirements.
        </p>

        <p>
            You can generate IdToken or Bearer Token by following the steps mentioned <a routerLink="/tokenGeneration">here</a>. 
        </p>
    </div>


</div>